import i18n, { use } from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import { Language } from '../components/common/types'
import { resources } from '../localization/resources'
import { supportedLanguages } from '../utils'

const enabledLanguages = supportedLanguages
  .filter((lang: Language) => lang.disabled === false)
  .map((lang: Language) => lang.value)

use(initReactI18next)
  .use(LanguageDetector as any)
  .init({
    resources: resources,
    lng: 'en',
    fallbackLng: 'en',
    supportedLngs: enabledLanguages,
    interpolation: {
      escapeValue: false,
    },
  })

export default i18n
